// Applique la palette de couleurs de la boutique (Studio de thème) en
// custom properties CSS sur :root. tailwind.config.js lit ces mêmes
// variables pour chaque couleur de marque (ink, gold, sand...) — aucun
// composant n'a besoin d'être touché pour qu'une personnalisation prenne
// effet partout où la classe correspondante (text-ink, bg-gold...) est
// utilisée.
const HEX_RE = /^#([0-9a-fA-F]{6})$/;

function hexToRgbTriplet(hex) {
  const match = HEX_RE.exec(hex);
  if (!match) return null;
  const int = parseInt(match[1], 16);
  return `${(int >> 16) & 255} ${(int >> 8) & 255} ${int & 255}`;
}

export default function applyPalette(palette) {
  if (!palette || typeof palette !== "object") return;
  const root = document.documentElement;
  Object.entries(palette).forEach(([key, hex]) => {
    const rgb = hexToRgbTriplet(hex);
    if (rgb) {
      root.style.setProperty(`--c-${key}`, rgb);
    } else {
      // Valeur vide ou invalide : on RETIRE la property au lieu de l'ignorer.
      // Les rôles de zone (--c-header_bg, --c-footer_bg…) valent « hérite »
      // quand ils sont absents, et c'est ce repli que tailwind.config.js
      // exprime. Sans ce retrait, repasser une zone en « hérite » depuis le
      // Studio n'aurait aucun effet tant que la page n'est pas rechargée.
      root.style.removeProperty(`--c-${key}`);
    }
  });
}
